import { Product } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';
import { UnitsOfMeasurement } from '../../models/order-management/units-of-measurement.model';

export enum ActionTypes {
  FETCH_UNITS = '[Open Platform] Fetch Units',
  LOAD_UNITS = '[Open Platform] Load Units',
  ADD_UNITS = '[Open Platform] Add Units',
  CLEAR_UNITS = '[Open Platform] Clear Units',
  NO_ACTION = '[Open Platform] No Action Units',
}

export class FetchUnits implements Action {
  readonly type = ActionTypes.FETCH_UNITS;
  constructor(public payload: { orderFormId: number; productId: number }) {}
}

export class LoadUnits implements Action {
  readonly type = ActionTypes.LOAD_UNITS;
  constructor(public payload: { orderFormId: number; product: Product }) {}
}

export class AddUnits implements Action {
  readonly type = ActionTypes.ADD_UNITS;
  constructor(public payload: { orderFormId: number; units: UnitsOfMeasurement[] }) {}
}

export class ClearUnits implements Action {
  readonly type = ActionTypes.CLEAR_UNITS;
  constructor() {}
}

export class NoAction implements Action {
  readonly type = ActionTypes.NO_ACTION;
  constructor() {}
}

export type Actions = FetchUnits | LoadUnits | AddUnits | ClearUnits | NoAction;
